import { Flex, IconButton, Text } from "@chakra-ui/react";
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
} from "react-icons/fi";
import { auditTexts } from "../../../../constants/auditTexts";
import type { AuditFilters, AuditTrailResponse } from "../../../../types";

interface AuditPaginatorProps {
  filters: AuditFilters;
  onFiltersChange: (filters: AuditFilters) => void;
  pagination?: AuditTrailResponse;
}

const AuditPaginator: React.FC<AuditPaginatorProps> = ({
  filters,
  onFiltersChange,
  pagination,
}) => {
  if (!pagination || pagination.totalPages <= 1) {
    return null;
  }

  const { currentPage, totalPages, count } = pagination;

  const handlePageChange = (page: number) => {
    onFiltersChange({ ...filters, page });
  };

  return (
    <Flex justify="space-between" align="center" p={4}>
      <Text>
        {auditTexts.pagination.showing} {(currentPage - 1) * filters.limit + 1}-
        {Math.min(currentPage * filters.limit, count || 0)}{" "}
        {auditTexts.pagination.of} {count} {auditTexts.pagination.records}
      </Text>
      <Flex>
        <IconButton
          aria-label={auditTexts.pagination.first}
          icon={<FiChevronsLeft />}
          onClick={() => handlePageChange(1)}
          isDisabled={currentPage === 1}
          mr={2}
        />
        <IconButton
          aria-label={auditTexts.pagination.previous}
          icon={<FiChevronLeft />}
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
          mr={2}
        />
        <Text p={2}>
          {currentPage} / {totalPages}
        </Text>
        <IconButton
          aria-label={auditTexts.pagination.next}
          icon={<FiChevronRight />}
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
          ml={2}
        />
        <IconButton
          aria-label={auditTexts.pagination.last}
          icon={<FiChevronsRight />}
          onClick={() => handlePageChange(totalPages)}
          isDisabled={currentPage === totalPages}
          ml={2}
        />
      </Flex>
    </Flex>
  );
};

export default AuditPaginator;
